/**
 * @file Type definitions for metrics.
 *
 * Helpful backend files/folders:
 * - https://github.com/Iterable/Iterable/blob/master/graphql/src/main/scala/com/iterable/services/graphqlserver/types/AnalyticsTypes.scala
 * - https://github.com/Iterable/Iterable/blob/master/platform/app/com/iterable/models/analytics
 * - https://github.com/Iterable/Iterable/blob/master/libs/journeys/src/main/scala/com/iterable/journeys/legacy/persistence/helpers/FlexMetricsSubTypes.scala
 */

/** Metric API names */
export enum SendMetric {
  TotalEmailSend = 'TotalEmailSend',
  EmailDeliveryRate = 'EmailDeliveryRate',
  EmailOpenRate = 'EmailOpenRate',
  EmailClickRate = 'EmailClickRate',

  // send push
  TotalPushSend = 'TotalPushSend',
  PushDeliveryRate = 'PushDeliveryRate',
  PushOpenRate = 'PushOpenRate',

  // send sms
  TotalSMSSend = 'TotalSMSSend',
  SMSDeliveryRate = 'SMSDeliveryRate',

  // send web push
  TotalWebPushSend = 'TotalWebPushSend',
  TotalWebPushClick = 'TotalWebPushClick',

  // send in app
  TotalInAppSend = 'TotalInAppSend',
  TotalInAppClick = 'TotalInAppClick',

  // embedded
  TotalEmbeddedRetrieved = 'TotalEmbeddedRetrieved',
  EmbeddedImpressionsRate = 'EmbeddedImpressionsRate',
  EmbeddedClickRate = 'EmbeddedClickRate',

  // whatsApp
  TotalWhatsAppSend = 'TotalWhatsAppSend',
  WhatsAppDeliveryRate = 'WhatsAppDeliveryRate',
  WhatsAppClickRate = 'WhatsAppClickRate',
}

/**
 * The categories to which a metric can belong.
 */
export enum MetricCategory {
  Engagement = 'Engagement',
  Delivery = 'Delivery',
  Audience = 'Audience',
  Retention = 'Retention',
  Conversions = 'Conversions',
}

/**
 * The types of values that a metric corresponds to.
 * This determines the how the metric is displayed in the UI.
 */
export enum MetricValueType {
  Number = 'number',
  Percentage = 'percentage',
  Currency = 'currency',
  Object = 'object',
}

export enum GraphQLWorkflowNodeResourceFilter {
  Campaign = 'Campaign',
  ContactList = 'ContactList',
  MessageChannel = 'MessageChannel',
  MessageType = 'MessageType',
  Webhook = 'Webhook',
}
